/** Mobile底部导航 */

import { useNavigate, useLocation } from 'react-router-dom';
import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
import {
  Assignment,
  QrCodeScanner,
  LocalShipping,
  FactCheck,
  CheckCircleOutline,
} from '@mui/icons-material';

const navItems = [
  { label: '任务池', path: '/mobile/tasks', icon: <Assignment /> },
  { label: '扫码绑IoT', path: '/mobile/scan', icon: <QrCodeScanner /> },
  { label: '装柜铅封', path: '/mobile/loading-seal', icon: <LocalShipping /> },
  { label: '节点质检', path: '/mobile/inspection', icon: <FactCheck /> },
  { label: '签收开箱', path: '/mobile/sign-unbox', icon: <CheckCircleOutline /> },
];

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  const currentValue = navItems.findIndex(
    (item) => location.pathname.startsWith(item.path)
  );

  return (
    <Paper
      sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 100 }}
      elevation={3}
    >
      <BottomNavigation
        value={currentValue >= 0 ? currentValue : 0}
        onChange={(_, newValue) => {
          navigate(navItems[newValue].path);
        }}
        sx={{
          '& .MuiBottomNavigationAction-root': {
            minWidth: 'auto',
            py: 0.75,
          },
          '& .MuiBottomNavigationAction-label': {
            fontSize: '0.625rem',
          },
        }}
      >
        {navItems.map((item) => (
          <BottomNavigationAction key={item.path} label={item.label} icon={item.icon} />
        ))}
      </BottomNavigation>
    </Paper>
  );
}
